/* Indyra region page: search, A to Z rail, sticky offsets, return path. */
(function () {
  var root = document.querySelector('.indyra-region');
  if (!root) return;

  var head = root.querySelector('.indyra-region__head');
  var list = document.getElementById('RegionList');
  var rail = document.getElementById('RegionRail');
  var query = document.getElementById('RegionQuery');
  var empty = document.getElementById('RegionEmpty');
  var ret = document.getElementById('RegionReturn');

  /* Send the shopper back to the page they came from. Same-site paths
     only, so the parameter cannot be used to bounce them elsewhere. */
  if (ret) {
    try {
      var from = new URLSearchParams(window.location.search).get('from');
      if (from && from.charAt(0) === '/' && from.charAt(1) !== '/') ret.value = from;
    } catch (e) {}
  }

  /* Clear the theme's sticky header, and let the letter headings stop
     below our own sticky search block. */
  function offsets() {
    var top = 0;
    var bar = document.querySelector('sticky-header, .header-wrapper, .section-header');
    if (bar) {
      var pos = window.getComputedStyle(bar).position;
      if (pos === 'fixed' || pos === 'sticky') top = bar.getBoundingClientRect().height;
    }
    root.style.setProperty('--region-top', top + 'px');
    if (head) root.style.setProperty('--region-head-h', head.getBoundingClientRect().height + 'px');
  }
  offsets();
  window.addEventListener('resize', offsets);
  window.addEventListener('load', offsets);

  var rows = Array.prototype.slice.call(list.querySelectorAll('.indyra-region__row'));
  var labels = Array.prototype.slice.call(list.querySelectorAll('.indyra-region__label'));

  labels.forEach(function (el) {
    var letter = el.getAttribute('data-letter');
    if (!letter) return;
    var b = document.createElement('button');
    b.type = 'button';
    b.textContent = letter;
    b.setAttribute('aria-label', 'Jump to ' + letter);
    b.addEventListener('click', function () {
      var y = el.getBoundingClientRect().top + window.scrollY
            - parseFloat(getComputedStyle(root).getPropertyValue('--region-top') || 0)
            - parseFloat(getComputedStyle(root).getPropertyValue('--region-head-h') || 0);
      window.scrollTo({ top: y, behavior: 'smooth' });
    });
    rail.appendChild(b);
  });

  function filter() {
    var term = (query.value || '').trim().toLowerCase();
    var hits = 0;
    rows.forEach(function (r) {
      var show = !term
        || r.getAttribute('data-name').indexOf(term) > -1
        || r.getAttribute('data-cur').indexOf(term) > -1;
      r.hidden = !show;
      if (show) hits++;
    });
    labels.forEach(function (el) { el.hidden = !!term; });
    rail.hidden = !!term;
    if (empty) empty.hidden = hits > 0;
  }

  query.addEventListener('input', filter);
  query.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    e.preventDefault();
    var first = rows.filter(function (r) { return !r.hidden; })[0];
    if (first) first.click();
  });
})();